import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/push_notification_statuses/{?id}')
abstract class AbstractPushNotificationStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_PushNotificationStatusReference;
}

export default AbstractPushNotificationStatusModel;
